import './style.sass';

import parse from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ShowMoreList from '../../layouts-components__common-cases/show-more-list';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonCollapseItem from '../../../common-components/common-collapse-item';
import CommonTitle from '../../../common-components/common-title';

const processList = [
    {
        title: `Обработка поисковых запросов клиента`,
        subtitle: `Проработка ниши и&nbsp;конкурентов, анализ семантики на&nbsp;частотность и&nbsp;геозависимость.`,
    },
    {
        title: `Дополнение семантики целевыми запросами`,
        subtitle: `Помимо фраз от&nbsp;клиента мы&nbsp;нашли еще порядка&nbsp;50% целевых запросов, по&nbsp;которым можно было работать. В&nbsp;конечном счете семантика насчитывала 90&nbsp;запросов по&nbsp;11&nbsp;регионам и&nbsp;2&nbsp;по&nbsp;поисковым системам.`,
    },
    {
        title: `Оптимизация мета-тегов на&nbsp;страницах каталога продукции`,
        subtitle: `Сгруппировали всю подходящую семантику и&nbsp;распределили по&nbsp;посадочным страницам. Переработали все описания тегов страниц каталога и&nbsp;точечно проработали основные страницы, на&nbsp;которых приходилась большая часть трафика.`,
    },
    {
        title: `Работа с текстами`,
        subtitle: `Проанализировали имеющиеся тексты, сделали приоритеты для переработки старого и написания нового контента, подготовили технические задания для копирайтеров, наладили систематическое обновление контента.`,
    },
    {
        title: `Настройка проекта по&nbsp;мониторингу семантики в&nbsp;целевых регионах`,
        subtitle: `Использовали сервис ALLPositions для ежедневного парсинга позиций по&nbsp;11&nbsp;городам и&nbsp;двум поисковым системам. Отдельно использовали свой сервис для мониторинга по&nbsp;основным ключам своих позиций и&nbsp;нескольких конкурентов.`,
    },
];

const hideProcessList = [
    {
        title: `Анализ региональной привязки сайта`,
        subtitle: `Фактор ранжирования по&nbsp;гео очень зависит от&nbsp;ниши, в&nbsp;которой компания хочет быть в&nbsp;ТОПе. В&nbsp;семантическом ядре этой ниши не&nbsp;было зависимости, из&nbsp;какого региона задаст запрос пользователь. Ответ будет одинаков и&nbsp;в&nbsp;Москве и&nbsp;в&nbsp;Ростове. Поэтому приемы поддоменов или отдельных карточек контактов тут не&nbsp;применялись, так как были&nbsp;бы неэффективны. В&nbsp;итоге мы&nbsp;выбрали вариант регистрации в&nbsp;справочниках Яндекс и&nbsp;Google как компанию без адреса, но&nbsp;доставляющую свою продукцию в&nbsp;11&nbsp;регионов.`,
    },
    {
        title: `Технический аудит сайта`,
        subtitle: `
            <div class="paragraph">Помимо контента, мета-тегов и&nbsp;ссылочного продвижения важно учитывать техническую составляющую: скорость загрузки страниц, корректную перелинковку, наличие правильных sitemap и&nbsp;robots.txt, битых ссылок, дубликатов, редиректов и&nbsp;другие параметры, исправление которых даст больше шансов на&nbsp;успешную индексацию.</div>
            <div class="paragraph">К&nbsp;примеру, выяснилось, что сайт был доступен по&nbsp;URL-адресам с&nbsp;www и&nbsp;без www. Это привело к&nbsp;появлению полной копии сайта в&nbsp;индексе поисковых систем. Для устранения проблемы мы&nbsp;настроили 301-й редирект на&nbsp;правильную версию, сайт стал корректно индексироваться.</div>
            `,
    },
    {
        title: `Создание необходимых посадочных страниц`,
        subtitle: `
                    <div class="paragraph">После анализа ниши можно выяснить необходимую структуру сайта, чтобы повысить позиции в&nbsp;выдаче. Мы&nbsp;определили список ключевых слов и&nbsp;его группировку, после чего стало понятно, каких страниц и&nbsp;где не&nbsp;хватает. Сделали ТЗ&nbsp;для таких страниц и&nbsp;наполнили контентом.</div>
                    <div class="paragraph">Клиент хотел быть в&nbsp;топе по&nbsp;таким высокочастотным ключам как: &laquo;ультрафильтрация&raquo; и&nbsp;&laquo;ультрафильтрация воды&raquo;. На&nbsp;момент начала сотрудничества сайт не&nbsp;ранжировался даже в&nbsp;ТОП-100. Мы&nbsp;подготовили, оптимизировали и&nbsp;разместили
                      <a class="nanoteh__link" target="_blank" rel="noopener noreferrer nofollow" href="https://www.membranium.com/ru/about-us/articles/ultrafiltraciya-vody/">экспертную статью</a> ,
                      которая позволила выйти в&nbsp;ТОП-5 Яндекса и&nbsp;Google.</div>
            `,
    },
    {
        title: `Исправление битых ссылок, которые выдают 404 ошибку`,
        subtitle: `Часто на&nbsp;сайтах в&nbsp;индексе есть несуществующие страницы. В&nbsp;навигации по&nbsp;сайту их&nbsp;можно и&nbsp;не&nbsp;найти, но&nbsp;поисковая система индексирует и&nbsp;видит, что сайт не&nbsp;в&nbsp;порядке. Это негативно влияет на&nbsp;индексацию и&nbsp;необходимо или закрыть от&nbsp;индексации такие страницы или сделать редиректы на&nbsp;нужные страницы. На&nbsp;проекте таких 404 ошибок было выявлено и&nbsp;исправлено более 100&nbsp;шт.`,
    },
    {
        title: `Закрытие ссылок на внешние источники`,
        subtitle: `На&nbsp;проекте не&nbsp;должно быть большого количества исходящих ссылок, иначе поисковая система может снижать ресурс в&nbsp;выдаче. Мы&nbsp;анализируем исходящие ссылки, часть удаляем по&nbsp;согласованию, а&nbsp;другую часть закрываем в&nbsp;атрибут nofollow, чтобы робот их&nbsp;не&nbsp;индексировал. Закрыли атрибутом nofollow сквозные ссылки на&nbsp;соцсети, а&nbsp;также ссылки на&nbsp;сайты дилеров.`,
    },
    {
        title: `Точечная проработка страниц`,
        subtitle: `Для самых приоритетных ключевых слов вручную прорабатываются посадочные страницы, контент, заголовки и&nbsp;перелинковка на&nbsp;эти страницы. У&nbsp;нас таких ключевиков было 80&nbsp;шт.`,
    },
    {
        title: `Анализ сниппетов в поисковых системах`,
        subtitle: `Улучшение и&nbsp;расширение сниппета&nbsp;&mdash; одна из&nbsp;приоритетных задач команды по&nbsp;SEO-продвижению. Для улучшения сниппетов мы&nbsp;подготовили привлекательные title и&nbsp;description с&nbsp;использованием эмоджи.`,
    },
    {
        title: `Конкурентный анализ`,
        subtitle: `
            <div class="paragraph">В&nbsp;анализе конкурентов мы&nbsp;используем сервис SimilarWeb и&nbsp;Ahrefs. С&nbsp;их&nbsp;помощью выявляем показатели посещаемости и&nbsp;источники трафика. В&nbsp;конкурентном анализе всего учитываем более 60&nbsp;параметров.</div>
            <div class="paragraph">Конкурентный анализ показал, что по&nbsp;целевой семантике приходится сражаться за&nbsp;ТОП с&nbsp;большими информационными порталами и&nbsp;специализированными интернет-магазинами. Это позволило вовремя выбрать правильную стратегию работы с&nbsp;контентом&nbsp;&mdash; подготовить экспертный контент для статейного раздела и&nbsp;тексты для страниц каталога.</div>
        `,
    },
    {
        title: `Ссылочное продвижение`,
        subtitle: `На&nbsp;этом этапе мы&nbsp;анализируем внешние ссылки конкурентов, их&nbsp;состав и&nbsp;качество, чтобы понимать какие брать доноры и&nbsp;типы ссылок: анкорные/безанкорные/нативные/статейные. Ссылки, размещенные на&nbsp;сторонних площадках в&nbsp;рамках этой стратегии, значительно ускорили продвижение запросов в&nbsp;ТОП, особенно, в&nbsp;Google.`,
    },
    {
        title: `Анализ корректности связки языковых версий`,
        subtitle: `Продукция клиента направлена не&nbsp;только на&nbsp;русскоязычных клиентов, но&nbsp;и&nbsp;на&nbsp;англоязычных, поэтому имеет две языковые версии сайта. В&nbsp;обязательном порядке мы&nbsp;проверяем корректности связки языковых версий и&nbsp;переходов на&nbsp;любой странице на&nbsp;другую языковую версию, все&nbsp;ли остается на&nbsp;местах, нет&nbsp;ли багов или не&nbsp;переведенных частей. В&nbsp;итоге обнаружили, что отсутствуют теги hreflang, помогающие Google определять страницы с&nbsp;несколькими языковыми версиями и&nbsp;соответствующим образом ранжировать&nbsp;их.`,
    },
    {
        title: 'Точечная работа по запросам не в топе',
        subtitle: `Когда проведены базовые работы, все сделано, приходит время доработок. Мы&nbsp;изучаем запросы, по&nbsp;которым не&nbsp;получилось выйти в&nbsp;ТОП и&nbsp;начинаем тестировать новые гипотезы. Например: увеличение числа вхождения ключа в&nbsp;текст, использование ключа в&nbsp;подзаголовках, усиление ссылочного по&nbsp;этому запросу, усиление внутренней перелинковки на&nbsp;страницу, усиление коммерческих факторов и&nbsp;т.д. При этом, от&nbsp;активного продвижения некоторых запросов, ранжироваться по&nbsp;которым хотел клиент, пришлось отказаться, так как окончательно подтвердился их&nbsp;неподходящий интент.`,
    },
];

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} caseName="nanoteh-process">
                <CommonTitle>Процесс</CommonTitle>
                <div className="nanoteh-process__wrapper">
                    <div className="nanoteh-process__info">
                        <div className="nanoteh-process__collapse-list">
                            {processList.map(({ title, subtitle }, index) => (
                                <CommonCollapseItem
                                    key={index}
                                    index={++index}
                                    triggerText={parse(title)}
                                    content={parse(subtitle)}
                                    classParent={'nanoteh-process__collapse-item'}
                                    numberColor={'#3498dc'}
                                />
                            ))}
                        </div>
                        <ShowMoreList
                            list={hideProcessList}
                            startIndex={5}
                            btnClassName="nanoteh-process__show-more"
                            containerListName="nanoteh-process__collapse-list"
                            itemListName="nanoteh-process__collapse-item"
                            numberColor={'#3498dc'}
                        />
                    </div>
                    <div className="nanoteh-process__img">
                        <img
                            src="/images/svg/nanotech/nanotech-process__img.svg"
                            alt=""
                            loading="lazy"
                        />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
